import { render, staticRenderFns } from "./NewPriceSPopupActive.vue?vue&type=template&id=aa1ae9c4&"
import script from "./NewPriceSPopupActive.vue?vue&type=script&lang=js&"
export * from "./NewPriceSPopupActive.vue?vue&type=script&lang=js&"
import style0 from "./NewPriceSPopupActive.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports